import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { RecipeCard, Chip, SectionHeader, Skeleton } from "@/components/kit";
import { toast } from "sonner";

const FILTERS = ["All", "trending", "beach", "wedding", "holiday", "party", "classic", "seasonal", "best rated"];

export default function Recipes() {
  const [recipes, setRecipes] = useState(null);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    setRecipes(null);
    const params = filter === "best rated" ? "?sort=best rated" : filter === "All" ? "" : `?category=${filter}`;
    api.get(`/recipes${params}`).then((r) => setRecipes(r.data));
  }, [filter]);

  return (
    <div className="mx-auto max-w-6xl px-4 py-8 lg:px-6">
      <SectionHeader overline="Discover what people are drinking" title="Recipe discovery" />
      <div className="mb-8 flex flex-wrap gap-2">
        {FILTERS.map((f) => <Chip key={f} data-testid={`recipe-filter-${f.replace(/ /g, "-")}`} active={filter === f} onClick={() => setFilter(f)}>{f === "All" ? "All" : f[0].toUpperCase() + f.slice(1)}</Chip>)}
      </div>
      {!recipes ? (
        <div className="columns-2 gap-5 lg:columns-4 masonry">{Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="mb-5 h-72 w-full" />)}</div>
      ) : (
        <div className="columns-2 gap-5 lg:columns-4 masonry">
          {recipes.map((r) => <div key={r.id}><RecipeCard r={r} onSave={() => toast.success(`Saved ${r.name}`)} /></div>)}
        </div>
      )}
    </div>
  );
}
